module.exports = __webpack_public_path__ + "img/20190418_154809_007.2337a817.jpg";